import { FORMAT_ELEMENT_COMMAND, LexicalEditor } from 'lexical';
import { INSERT_HORIZONTAL_RULE_COMMAND } from '@lexical/extension';
import { INSERT_EMBED_COMMAND } from '@lexical/react/LexicalAutoEmbedPlugin';

import React from 'react';
import DropDown, { DropDownItem } from '../../../ui/DropDown';
import { InsertMediaDialog } from '../../MediaPlugin';
import GiphySearch from '../../../components/GiphyModal';
import { INSERT_EXCALIDRAW_COMMAND } from '../../ExcalidrawPlugin';
import { InsertTableDialog } from '../../TablePlugin';
import { INSERT_POLL_COMMAND } from '../../PollPlugin';
import InsertLayoutDialog from '../../LayoutPlugin/InsertLayoutDialog';
import { InsertEquationDialog } from '../../EquationsPlugin';
import { INSERT_COLLAPSIBLE_COMMAND } from '../../CollapsiblePlugin';
import { EmbedConfigs } from '../../AutoEmbedPlugin';

interface InsertDropdownProps {
  editor: LexicalEditor;
  isEditable: boolean;
  showModal: any;
}

export function InsertDropdown({ editor, isEditable, showModal }: InsertDropdownProps) {
  return (
    <DropDown
      disabled={!isEditable}
      buttonClassName="toolbar-item spaced"
      buttonLabel="Insert"
      buttonAriaLabel="Insert specialized editor node"
      buttonIconClassName="icon plus"
    >
      <DropDownItem
        onClick={() => editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined)}
        className="item"
      >
        <i className="icon horizontal-rule" />
        <span className="text">Horizontal Rule</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          showModal('Insert Media', (onClose) => (
            <InsertMediaDialog activeEditor={editor} onClose={onClose} />
          ));
        }}
        className="item"
      >
        <i className="icon image" />
        <span className="text">Media</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          showModal('', (onClose) => <GiphySearch activeEditor={editor} onClose={onClose} />);
        }}
        className="item"
      >
        <i className="icon gif" />
        <span className="text">GIF</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => editor.dispatchCommand(INSERT_EXCALIDRAW_COMMAND, undefined)}
        className="item"
      >
        <i className="icon diagram-2" />
        <span className="text">Excalidraw</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          showModal('Insert Table', (onClose) => (
            <InsertTableDialog activeEditor={editor} onClose={onClose} />
          ));
        }}
        className="item"
      >
        <i className="icon table" />
        <span className="text">Table</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          editor.dispatchCommand(INSERT_POLL_COMMAND, undefined);
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center');
        }}
        className="item"
      >
        <i className="icon poll" />
        <span className="text">Poll</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          showModal('Insert Columns Layout', (onClose) => (
            <InsertLayoutDialog activeEditor={editor} onClose={onClose} />
          ));
        }}
        className="item"
      >
        <i className="icon columns" />
        <span className="text">Columns Layout</span>
      </DropDownItem>

      <DropDownItem
        onClick={() => {
          showModal('Insert Equation', (onClose) => (
            <InsertEquationDialog activeEditor={editor} onClose={onClose} />
          ));
        }}
        className="item"
      >
        <i className="icon equation" />
        <span className="text">Equation</span>
      </DropDownItem>

      {/* <DropDownItem onClick={insertStickyNote} className="item">
        <i className="icon sticky" />
        <span className="text">Sticky Note</span>
      </DropDownItem> */}

      <DropDownItem
        onClick={() => editor.dispatchCommand(INSERT_COLLAPSIBLE_COMMAND, undefined)}
        className="item"
      >
        <i className="icon caret-right" />
        <span className="text">Collapsible container</span>
      </DropDownItem>

      {/* <DropDownItem
        onClick={() => {
          showModal('Search and Insert X Posts', (onClose) => (
            <XSearchModal activeEditor={editor} onClose={onClose} />
          ));
        }}
        className="item"
      >
        <i className="icon tweet w-5 h-5 bg-contain" />
        <span className="text">Search X Posts</span>
      </DropDownItem> */}

      {EmbedConfigs.map((embedConfig) => (
        <DropDownItem
          key={embedConfig.type}
          onClick={() => {
            editor.dispatchCommand(INSERT_EMBED_COMMAND, embedConfig.type);
          }}
          className="item"
        >
          {embedConfig.icon}
          <span className="text">{embedConfig.contentName}</span>
        </DropDownItem>
      ))}
    </DropDown>
  );
}
